import { useTranslation } from 'react-i18next';
import { LegalPageLayout } from '../components/layout/LegalPageLayout';
import { LegalContent } from '../components/legal/LegalContent';
import { TERMS_CONTENT } from '../content/terms';

export const TermsPage = () => {
  const { t } = useTranslation();

  return (
    <LegalPageLayout title={t('legal.terms.title')}>
      <LegalContent sections={TERMS_CONTENT} />
    </LegalPageLayout>
  );
};
